import VideoWatchLaterRemoveIcon from '@atlaskit/icon-lab/core/video-watch-later-remove';
import * as React from 'react';

export function SvgWatchLaterRemove() {
  return <VideoWatchLaterRemoveIcon label="" testId="ads-refreshed-icon" />;
}
